import { Injectable } from '@angular/core';

// Services
import { NavigationParam, ServiceBase } from '../service-base';

const CLASS_NAME = 'SalesSettings';
const ENDPOINT = `/sales-settings/`;

const NAVIGATIONS: NavigationParam[] = [
    { key: 'credit-note-attachments', path: 'credit-note-attachments/', childClass: 'File' },
    { key: 'invoice-attachments', path: 'invoice-attachments/', childClass: 'File' },
    { key: 'quotation-attachments', path: 'quotation-attachments/', childClass: 'File' },
]

@Injectable({
    providedIn: 'root'
})
export class SalesSettingsService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addNavigations(NAVIGATIONS);
    }
}
